// extracted by mini-css-extract-plugin
module.exports = {"svmurut":"svmurut","content":"content","s11ve7n9":"s11ve7n9"};